module.exports = {"433124102":"龙潭镇","433124103":"民乐镇","433124105":"吉卫镇","433124106":"麻栗场镇","433124107":"雅酉镇","433124108":"边城镇","433124109":"花垣镇","433124110":"双龙镇","433124111":"石栏镇","433124200":"长乐乡","433124206":"猫儿乡","433124213":"补抽乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/433124.json
// module id = 2064
// module chunks = 0